import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackReportAddressModalOpen = () => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'AddressIssuesPopupOpen',
    label: ''
  });
};
